import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { LieFraction } from '../../api/models';

export type TABLE_TYPE = Table<LieFraction>;

export const TABLE = 'lieFraction';
const SCHEMA = 'lieFractionId, headTypeId, sortId'; // headTypeId index for quick lookups

class LieFractionDatabase implements DataRepository<LieFraction> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<LieFraction | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: LieFraction, key: Key): Promise<LieFraction> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: LieFraction[]): Promise<LieFraction[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<LieFraction[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const LieFractionDB = new LieFractionDatabase(db);
